export const DASHBOARD_LANGUAGE = {
  en: 'English',
  fr: 'Français',
  ru: 'Русский',
  'es-MX': 'Español Mexicano',
  es: 'Español'
};
